"use client";

import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

import { useViewport } from "./hooks/useViewport";

interface IProps {
  mobile?: React.ReactNode;
  desktop?: React.ReactNode;
  /**
   * Setting this prop will force the usage of CSS media queries and avoid JS viewport
   */
  noJS?: boolean;
}

/**
 * This component can be used to conditionally display content based on the viewport without using
 * useViewport or Viewport.getDefault(). It uses responsiveMediaQueries to only display the component
 * assigned to the current viewport in case of SSR of if explicitly set through the "noJS" prop
 * @deprecated Use `@faire/web--source/ui/ResponsiveContentV2#ResponsiveContentV2`
 * @supersededBy "@faire/web--source/ui/ResponsiveContentV2#ResponsiveContentV2"
 * @trackcomponent
 */
export const ResponsiveContent: React.FC<IProps> = (props) => {
  const { mobile, desktop, noJS } = props;
  const isSSR = useIsSSR();
  const viewport = useViewport();
  if (isSSR || noJS) {
    return (
      <>
        <MobileOnly>{mobile}</MobileOnly>
        <DesktopOnly>{desktop}</DesktopOnly>
      </>
    );
  }
  return <>{viewport.isMobile ? mobile : desktop}</>;
};

const MobileOnly = styled.span`
  display: inline-block;
  ${responsiveMediaQueries.tabletAndAbove} {
    display: none;
  }
`;

const DesktopOnly = styled.span`
  display: inline-block;
  ${responsiveMediaQueries.mobile} {
    display: none;
  }
`;
